
export const  language=[
    {i_id:'zh_cn',vc_name:'简体中文',vc_sort_name:'中文'},
    {i_id:'en_us',vc_name:'English ',vc_sort_name:'英文'},
    {i_id:'vi_vn',vc_name:'Việt nam',vc_sort_name:'越南语'},
    {i_id:'fr_fr',vc_name:'French',vc_sort_name:'法语'},
];